import axios from "axios";
// import { loadSession,saveSession } from './session';
// import store from '../../app';
// import { getToken } from '../common/utils/session';

export const API_URL = 'https://api.bigbranding.com.au/';
export const APP_URL = 'https://app.bigbranding.com.au';

console.log("API_URL: ===============>", API_URL);

// const getObservable = (options) => { //config: CitiznApi
//   return new Promise(function (resolve, reject) {
//     var url = options.url;
//     const queryParams = options.params;
//     const data = options.data;
//     const method = options.method;
//     var headers = [];
//     const isprotected = options.protected;
//     headers['Content-Type'] = 'multipart/form-data'
//     url = API_URL+url;

//     axios.interceptors.request.use(
//       config => {
//           // const state = store.getState();
//           // const users = state.get('users');
//           // const token = users['token_bigbrand'];
//           var token = "";
//           if (isprotected) {
//             var cursession = loadSession();
//             if(cursession == undefined)
//               location.href = "/login";
//             var username = "";
//             if("token" in cursession)
//               token = cursession.token; 
//             else
//               location.href = "/login";

//             if (token) {
//                 config.headers['Authorization'] = "Bearer " + token;
//             }
//           }
//           config.headers['Content-Type'] = 'multipart/form-data';
          
//           return config;
//       },
//       error => {
//           // Promise.reject(error)
//       });

//       axios.interceptors.response.use((response) => {
//         return response
//     }, function (error) {
//         const originalRequest = error.config;
    
//         if (error.response.status === 401 ) {
//             router.push('/login');
//             return error;
//         }
//         return error;
//     });

//     switch (method) {
//       case "get":
//         axios
//           .get(url,{params: queryParams})
//           .then((response)=> {
//             resolve(response)
//           });
//         break;
//       case "post":
//         // if (headers['Content-Type'] == 'multipart/form-data') {
//         // } else {
//         // }
//         const res = axios
//         .post(url,data)
//         .then((response)=> {
//           resolve(response)
//         })
//         .catch((error)=> {
//             console.log(error);
//         });
//         break;
//       case "put":
//         // return addHeaders(
//         //   agent
//         //     .put(url)
//         //     .query(queryParams)
//         //     .send(data)
//         // ).then(getResponse);
//         break;
//       case "patch":
//         // return addHeaders(agent.patch(url).send(data)).then(getResponse);
//       case "delete":
//         axios
//           .delete(url,queryParams)
//           .then((response)=> {
//             resolve(response)
//           });
//         break;
//       default:
//         reject("error");
//     }
//   });
// };

// export const request = (options) => { //options: ICitiznApi
//   return getObservable(options);
// };


export const downloadFile=async(url, filename="download.pdf")=>{
    
    // axios.get('/brands/index').then(res => {
    //     console.log('res.data',res.data)
    //     if(res.data.status == "success")
    //       setTableData(res.data.data);
    //   })    

    // request({
    //   url: url,
    //   protected: true,
    //   method: "download",
    //   data: {},
    //   params: {}
    // })
    axios
    .request({url,method:'GET', responseType: 'blob'})
    .then(({ data }) => {
  
      const downloadUrl = window.URL.createObjectURL(new Blob([data]));
  
      const link = document.createElement('a');
  
      link.href = downloadUrl;
  
      link.setAttribute('download', filename); //any other extension
  
      document.body.appendChild(link);
  
      link.click();
  
      link.remove();
  
    })
    .catch(err => {
      
    });
  }


export const getFileContent=async(url, filename="download.pdf")=>{
  
  let result = await axios
  .request({url,method:'GET', responseType: 'blob'})

  let data = result.data; 
  const downloadUrl = window.URL.createObjectURL(new Blob([data]));    
  return downloadUrl
}